export const strings = {
  networkOffline: {
    title: 'Internet Connection Lost',
    message:
      "Your computer seems to be offline. We'll keep trying to reconnect.",
  },
  networkCriticalLatency: {
    title: 'Network connection warning',
    message:
      "We're detecting connectivity issues. Please check your internet connection.",
  },
} as const;
